import styled from 'styled-components';
import media from "styled-query"

export const Container = styled.section`
  display: flex;
  max-height: 100vh;
  height: 100vh;
  width: 100%;

  /* background: #0080003b; */
`;

export const Content = styled.div`
  display: flex;
  flex: 3;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: var(--background);

  h1 {
    font-size: 3rem;

    ${media.lessThan("1023px")`
      font-size: 2rem;
    `}
  }

  .spotlight {
    font-size: 3rem;
    font-weight: bold;
    color: var(--primary);
    ${media.lessThan("1023px")`
      font-size: 2rem;
    `}
  }

  ${media.lessThan("1023px")`
    margin: 0 24px;
  `}

  /* background: #ff000036; */
`;

export const Image = styled.div`
  display: flex;
  flex: 2;
  position:relative;

  ${media.lessThan("1023px")`
    display: none;
  `}

  /* background: #a6ecec5e; */
`;

export const GradientW = styled.div`
  position: absolute;
  z-index: 999;
  width: 100px;
  height: 100%;
  /* background: red; */
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, transparent 100%);
`;

export const GradientH = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 125px;
  top: 0;
  /* background: red; */
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 65%, transparent 100%);
`;

export const Input = styled.form`
  border: 2px solid var(--black);
  /* width: 70%; */
  max-width: 500px;
  height: 70px;
  border-radius: 35px;
  margin: 2rem 0 1rem 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 25px;

  span {
    font-weight: bold;
  }

  input {
    width: 100%;
    flex: 1;
    border: 0;
    margin-left: 2px;
    color: var(--primary);
    font-size: 1rem;
    font-weight: bold;

    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: var(--primary);
    }

    ${media.lessThan("1023px")`
      width: 100%;
    `}

    /* background: blue; */
  }

  button {
    height: 60px;
    width: 80px;
    border: none;
    background: var(--black);
    color: var(--white);
    font-weight: bold;
    border-radius: 30px;
    margin-right: 5px;
  }

  /* background: red; */
`;

export const Info = styled.div`
  display: flex;

  ${media.lessThan("530px")`
    h2 {
      font-size: 1.5rem;
    }
  `}

  ${media.lessThan("425px")`
    h2 {
      font-size: 1.4rem;
    }
  `}

`;

export const StaticImageNormal = styled.div`
  display: block;
  ${media.lessThan("530px")`
      display: none;
  `}
`;

export const StaticImageResponsive = styled.div`
  display: none;
  ${media.lessThan("530px")`
    display: block;
  `}
`;